import { Utilities as U } from '../utilities/utilities.model';
import { CommodityModel } from './commodity.model';
import { ModulePermissionModel, ProfilePermissionModel } from './user-permission.model';


// TODO
// decidere se trasferirla dentro in user-detail.components.ts

// Questa classe serve per rappresentare l'entità Modulo, che contiene i vari profili associati all'utenza
// Il progetto utilizza invece il caso inverso: l'entità Profilo contiene il campo Modulo
export class ModuleProfileAdapterModel {

  id: string = '';
  module_id: string = '';
  module_key: string = '';
  module_key_old?: string = '';
  profiles: ProfilePermissionModel[] = [];
  icon?: string = '';
  //centerSelected?: any; è nel profilo non qui

	constructor(model?: any) {
		
    if (U.isEmpty(model)) {
      return;
		}

		this.id = model.id || model.module_id || model.id_module; //Dovrebbe essere model.id
    this.module_id  = model.module_id;
    this.module_key = model.module_key;
    this.module_key_old = model.module_key_old;
    this.profiles = model.profiles ? model.profiles.map(x => new ProfilePermissionModel(x)) : [model.profile];
    this.icon = model.icon;
    //this.centerSelected = model.centerSelected;
	}
}  

/**

export class ProfileNemoModel {
  id              : string = '';
  name            : string = '';
  key             : string = '';
  module          : ModulePermissionModel;
  description     : string = '';
  permissions     : string[];
  is_custom       : boolean;
  has_commodities : boolean;
  commodities     : CommodityModel[];
  created_at      : string = '';
  updated_at      : string = '';
  type            : string | EPprofileType;
  current         : boolean;

	constructor(model?: any) {
		
    if (U.isEmpty(model)) {
      return;
		}

    this.id              = model.id;
    this.name            = model.name;
    this.key             = model.key;
    this.module          = model.module;
    this.description     = model.description;
    this.permissions     = model.permissions;
    this.is_custom       = model.is_custom;
    this.has_commodities = model.has_commodities;
    this.commodities     = model.commodities ? model.commodities.map(x => new CommodityModel(x)) : [];
    this.created_at      = model.created_at;
    this.updated_at      = model.updated_at;
    this.type            = model.type;
    this.current         = model.current;
  }
}

// {
//   "id": "b3aacc00-bcec-8479-3921-341e1e6c2595",
//   "name": "Booking relief bookings team",
//   "key": "module_relief_bookings_team",
//   "module": {
//       "id_module": "bda586a3-3aa2-4bb8-b62e-d597a26e7469",
//       "key": "bookings-relief",
//       "name": "Bookings Relief",
//       "description": "Modulo RELIEF Bookings",
//       "created_at": "2021-09-27T19:05:07.079123+00:00"
//   },
//   "description": "Booking relief bookings team",
//   "permissions": [ ],
//   "is_custom": false,
//   "has_commodities": false,
//   "commodities": [],
//   "created_at": "2021-09-27T19:05:07.079123+00:00",
//   "updated_at": null,
//   "type": "ADMIN",
//   "current": true
// },

*/ 

export enum EPprofileType {
  ADMIN = 'ADMIN',
  DEALER = 'DEALER',
  CENTER = 'CENTER',
  CENTER_SUPER_USER = 'CENTER_SUPER_USER',
}